


var protocol = window.location.href;
/* Le numéro whatsapp vers lequel redirige le bouton */ 
var localnumber = '656999989';
var countrycode = '237';

var phonenumber = countrycode+localnumber+'&text=';
var starttext = 'Je suis intéressé par ce produit :';
var whastart = 'https://api.whatsapp.com/send?phone='+phonenumber;

var completetext = starttext+' '+protocol;

 completetext = completetext.replace(/Blue/g, "red");
 completetext = completetext.replace(/\s/g, '%20')
 completetext = completetext.replace(/é/g, "%C3%A9");
 completetext = completetext.replace(/:/g, "%3A");
 completetext = completetext.replace(/\//g, "%2F");
 completetext = completetext.replace(/è/g, "%C3%A8");
 completetext = completetext.replace(/è/g, "%C3%A0");
 completetext = completetext.replace(/,/g, "%2C");

 link = whastart+completetext

document.getElementById("whatsappbtn").href = link; 